import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

// Load the highcharts-more module for polar charts
require("highcharts/highcharts-more")(Highcharts);

const RadialBarChart = () => {
  const chartData = {
    draft: 10,
    inProgress: 20,
    readyForSubmission: 30,
    approved: 40,
    rejected: 50,
    aiPending: 60,
    aiCompleted: 70,
    aiFailed: 80,
  };

  const categories = [
    "Draft",
    "In Progress",
    "Ready",
    "Approved",
    "Rejected",
    "Pending",
    "Completed",
    "Failed",
  ];
  const data = Object.values(chartData);

  const options = {
    chart: {
      polar: true,
      type: "column",
    },
    title: {
      text: "",
    },
    pane: {
      size: "85%",
    },
    xAxis: {
      categories: categories,
      tickmarkPlacement: "on",
      lineWidth: 0,
    },
    yAxis: {
      gridLineInterpolation: "polygon",
      lineWidth: 0,
      min: 0,
      maxPadding: 0.1,
    },
    tooltip: {
      shared: true,
      pointFormat: "<b>{point.y}</b> items",
    },
    plotOptions: {
      column: {
        pointPadding: 0,
        groupPadding: 0,
        dataLabels: {
          enabled: true,
          format: "{point.y}",
        },
        states: {
          hover: {
            enabled: true,
            brightness: 0.2,
          },
        },
        point: {
          events: {
            click: function () {
              alert(`You clicked on ${this.category}: ${this.y} items`);
            },
          },
        },
      },
    },
    series: [
      {
        name: "Statuses",
        data: data,
        pointPlacement: "on",
        colorByPoint: true,
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default RadialBarChart;
